var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 44,
    viewBox: "0 0 15 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 5",
    d: "M14.6746 21.4739C14.874 21.7963 14.874 22.2037 14.6746 22.5261L1.85044 43.2573C1.32063 44.1138 -2.66784e-07 43.7384 -2.22762e-07 42.7313L1.58962e-06 1.26875C1.63364e-06 0.26164 1.32063 -0.11381 1.85044 0.742674L14.6746 21.4739Z",
    fill: "#ADD2D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.722e223fbc5261fdec61bf9d4d1d84a7.svg";
export { ForwardRef as ReactComponent };